import React, {Component} from 'react';
import './index.css'
import BsySlidePane from "../BsySlidePane";
import BsyCheckBoxGroup from "../BsyCheckBoxGroup";
import BsyWebhookLogPane from "../BsyWebhookLogPane";
import BsyDialog from "../BsyDialog";
import BsyStructureSlide from "../BsyStructureSlide";
import BsyWebhookDoc from "../BsyWebhookDoc";
import AlertListSelectAppPopupPane from "../BsyAlertListDetail/selectAppPopupPane";
import imgkfptweihuoqu from "../../images/img_kfpt_weihuoqu@2x.png";
import wushujutuisong from "../../images/img_wushujutuisong@2x.png";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import {NavLink} from "react-router-dom";


class BsyWebhookPane extends Component {
    constructor(props) {
        super(props);
        this.serverVal = React.createRef();
 
    }

    componentDidMount() {
        this.loadWebHook()
    }

    loadWebHook = () =>{
        this.setState({success:false})
        React.axios("/webhook/info",{
            type:2
        }).then((res)=>{
            this.setState({list:res.data.data,openapi:res.data.openapi,success:true})
        })
    }
    
    checkItems = [{
        text: React.language("data.api.trigger.create"),
        value: 0
    },{
        text: React.language("data.api.trigger.update"),
        value: 1
    },{
        text: React.language("data.api.trigger.remove"),
        value: 2
    },{
        text: React.language("data.api.trigger.recover"),
        value: 3
    },{
        text: React.language("data.api.trigger.formUpdate"),
        value: 4
    },{
        text: React.language("data.api.trigger.comment"),
        value: 6
    },{
        text: React.language("data.api.trigger.comment.edit"),
        value: 7
    }]

    checkItemsFlow = [{
        text: React.language("data.api.flow.status"),
        show: false,
        value: 5
    }]

    webHookCheck=[]

    state = {
        eventType: 1,
        form:{},
        success:false,
        list:[]
    }

    openWebHookLog = (val) =>{
        return ()=>{
            const {openapi} = this.state
            BsySlidePane({
                title: React.language('data.api.log'),
                hasHeader: true,
                onContentCreate: (ref) => {
                    return <BsyWebhookLogPane id={val.id} openapi={openapi} status={val.status} />
                },
            })
        }
    }

    checkChange = (value) =>{
        // console.log(value)
    }

    selectForm = (event) =>{
        let current = event.currentTarget
        BsyDialog({
            title: React.language("form.select"),
            height: 540,
            width: 720,
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onContentCreate: () => {
                return <AlertListSelectAppPopupPane
                    onlyForm = {true}
                    noHome={true}
                    appid={this.state.appid}
                    formid={this.state.formid}
                    getValue={this.getPopupValue} />
            },
            onOk: () => {
                if (!this.value) {
                    return false
                }

                const newState = {
                    ...this.state,
                    ...this.value,
                }
                this.onStopEdit({
                    appid: newState.appid,
                    formid: newState.formid,
                    name: newState.name,
                    icon: newState.icon,
                    hasCoop:newState.hasCoop,
                    type:newState.type,
                    appinfo:newState.appinfo,
                },current)
            }
        })
    }

    onStopEdit = (val,event) =>{
        while(event.hasChildNodes()) //当table下还存在子节点时 循环继续
        {
            event.removeChild(event.firstChild);
        }
        if(!val.hasCoop){
            event.parentNode.parentNode.parentNode.getElementsByClassName("open-event-flow")[0].style.display = "block"
        }else{
            event.parentNode.parentNode.parentNode.getElementsByClassName("open-event-flow")[0].style.display = "none"
        }
        event.innerHTML = `
          <div class="appName">
            <div class="app-icon color-cover-${val.appinfo.style.color}">
              <div class="imgbg-bby-app imgbg-bby-app-${val.appinfo.style.icon}"></div>
            </div>
            <span>${val.appinfo.appname}</span>
          </div>
          <div class="line-center"></div>
          <div class="formName" style="margin-left: 5px">
            <i class="node-icon icon-bsy-${val.type}${val.hasCoop ? "" : "-flow"} ${
              val.icon <= 24 ? `icon-bsy-form-${val.icon}` : `icon-new-bsy-form-${val.icon}`
            }"></i>
            <span>${val.name}</span>
          </div>
        `;

        this.formValue = val
    }

    randomWord = (randomFlag, min, max) =>{
        let str = "",
            range = min,
            arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

        // 随机产生
        if(randomFlag){
            range = Math.round(Math.random() * (max-min)) + min;
        }
        for(let i=0; i<range; i++){
            let pos = Math.round(Math.random() * (arr.length-1));
            str += arr[pos];
        }
        this.secret = str;
        return str;
    }

    createSecret = (event) =>{
        event.currentTarget.parentNode.getElementsByTagName("input")[0].value = this.randomWord(false,24)
    }

    getPopupValue = (ref) =>{
        this.value = ref;
        // console.log(ref)
    }

    secretChange = (event) =>{
        this.secret = event.currentTarget.value;
    }

    testServer = () =>{
        var reg=/^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)([\w.]+\/?)\S*/;
        if(!reg.test(this.serverVal.current.value)){
            tipAlert({
                type: 'warning',
                msg: React.language('server.url.tip')
            })
            return
        }

        React.axios("/webhook/pingurl",{
            url:this.serverVal.current.value
        }).then((res)=>{
            if(res.data.data.status_code === 200){
                tipAlert({
                    type:"success",
                    msg:React.language('url.server.tip1')
                })
            }else{
                tipAlert({
                    type:"error",
                    msg:React.language('url.server.tip2',{code:res.data.data.status_code})
                })
            }
        })
    }


    createWebHook = (d) =>{
        return ()=>{
            let form = d ? d : this.state.form;
            if(d){
                this.webHookCheck = d.event_info;
                this.secret = d.encrypt_key;
                this.formValue = d.forminfo
            }else{
                this.webHookCheck = []
            }
            this.createPane = BsySlidePane({
                title: React.language('data.api'),
                hasHeader: true,
                onContentCreate: (ref) => {
                    return <div className="OpenContent" key={form.formid}>
                        <div className="content-body">
                            <div className="content">
                                <div className="open-selectForm">
                                    <div className="open-title"><span>{React.language('form.select')}</span></div>
                                    <div className="open-cont">
                                        {d ? <a href={`${window.rootDirectroy}/dashboard/app/${d.forminfo.appid}/${d.forminfo.type}/${d.forminfo.formid}/edit`} target="_blank" className={"open-form-name"}>{
                                                <>
                                                    {form.forminfo.appinfo && <>
                                                        <div className="appName">
                                                            <div
                                                                className={`app-icon color-cover-${form.forminfo.appinfo.style.color}`}>
                                                                <div
                                                                    className={`imgbg-bby-app imgbg-bby-app-${form.forminfo.appinfo.style.icon}`}/>
                                                            </div>
                                                            <span>{form.forminfo.appinfo.appname}</span>
                                                        </div>
                                                        <div className="line-center"/>
                                                    </>
                                                    }

                                                    <div className="formName" style={{marginLeft:form.forminfo.appinfo ? "5px" : ""}}>
                                                        <i className={`node-icon icon-bsy-${form.forminfo.type}${form.forminfo.hasCoop==="0" ? "-flow" : ""} ${form.forminfo.icon<=24?`icon-bsy-form-'${form.forminfo.icon}`:`icon-new-bsy-form-'${form.forminfo.icon}`}`}/>
                                                        <span>{form.forminfo.name}</span>
                                                    </div>
                                                </>
                                            }</a> :
                                            <div className={"open-form-name"}
                                                 onClick={this.selectForm}>{
                                                <span>{React.language('select.form')}</span>
                                            }</div>}
                                    </div>
                                </div>
                                <div className="open-server">
                                    <div className="open-title"><span>{React.language('data.api.serverUrl.config')}</span></div>
                                    <div className="open-cont">
                                        <div className="cont-server"><input maxLength={255} placeholder={React.language('server.url.tip1')} defaultValue={form.url} ref={this.serverVal} type="text" id="open-server-val"/>
                                            <div className="cont-btn" onClick={this.testServer}>{React.language('data.api.server.test')}</div></div>
                                    </div>
                                </div>
                                <div className="open-secret">
                                    <div className="open-title"><span>Secret</span></div>
                                    <div className="open-cont">
                                        <div className="cont-secret"><input defaultValue={form.encrypt_key} onChange={this.secretChange} type="text" id="open-secret-val" maxLength={24}/>
                                            <div className="cont-btn" onClick={this.createSecret}>{React.language('data.api.secret.create')}</div></div>
                                    </div>
                                </div>
                                <div className="open-event">
                                    <div className="open-title"><span>{React.language('push.event')}</span></div>
                                    <div className="open-cont">
                                        <BsyCheckBoxGroup items={this.checkItems} onStopEdit={this.checkChange} value={form.event_info ? form.event_info : this.webHookCheck}/>
                                    </div>
                                </div>
                                <div className="open-event-flow" style={{display:d && d.forminfo && !d.forminfo.hasCoop ? "block" : "none"}}>
                                    <div className="open-title"><span>{React.language('push.event.flow')}</span></div>
                                    <div className="open-cont">
                                        <BsyCheckBoxGroup items={this.checkItemsFlow} onStopEdit={this.checkChange}
                                                     value={form.event_info ? form.event_info : this.webHookCheck}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content-footer">
                            <div className="open-btn-save" onClick={this.onSave(ref,d)}><span>{React.language('save')}</span></div>
                        </div>
                    </div>
                },
            })
        }
    }
    onSave = (ref,d) =>{
        return () =>{
            if(this.webHookCheck.length<=0){
                tipAlert({
                    type: 'warning',
                    msg: React.language('push.event.tip')
                })
                return
            }else if(!this.serverVal.current.value){
                tipAlert({
                    type: 'warning',
                    msg: React.language('data.api.server.target')
                })
                return
            }else if(!this.formValue){
                tipAlert({
                    type: 'warning',
                    msg: React.language('select.form')
                })
                return
            }
            var reg=/^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)([\w.]+\/?)\S*/;
            if(!reg.test(this.serverVal.current.value)){
                tipAlert({
                    type: 'warning',
                    msg: React.language('server.url.tip')
                })
                return
            }


            let params =d ? {
                "type":2, //类型  表单数据推送值为 2 通讯录推送为 1
                "appId":this.formValue.appid, //表单
                "formId":this.formValue.formid, //应用
                "id": d.id, //推送对应的唯一id
                "status":d.status, //状态
                "url":this.serverVal.current.value, //地址
                "forminfo":this.formValue, //表单信息
                "event_info":this.webHookCheck, //具体事件状态
                "encrypt_key": this.secret //加密字符串
            }:{
                "type":2, //类型  表单数据推送值为 2 通讯录推送为 1
                "appId":this.formValue.appid, //表单
                "formId":this.formValue.formid, //应用
                "url":this.serverVal.current.value, //地址
                "forminfo":this.formValue, //表单信息
                "event_info":this.webHookCheck, //具体事件状态
                "encrypt_key": this.secret //加密字符串
            }

            React.axios("/webhook/update",{
                ...params
            }).then((res)=>{
                if(res.data.errcode === 1){
                    tipAlert({
                        type:"error",
                        msg:res.data.errmsg
                    })
                    return
                }
                this.webHookCheck = [];
                this.formValue = null;
                this.secret = "";
                this.serverVal.current.value = "";
                this.loadWebHook()
                ref.closeAlter()
            })
        }
    }
    timeCont = (val) =>{
        let time = ""
        val.map((d)=>{
            switch (d) {
                case 0:
                    time += React.language('data.api.trigger.create')+"；"
                    break;
                case 1:
                    time += React.language('data.api.trigger.update')+"；"
                    break;
                case 2:
                    time += React.language('data.api.trigger.remove')+"；"
                    break;
                case 3:
                    time += React.language('data.api.trigger.recover')+"；"
                    break;
                case 4:
                    time += React.language('data.api.trigger.formUpdate')+"；"
                    break;
                case 5:
                    time += React.language('data.api.flow.status')+"；"
                    break;
                case 6:
                    time += React.language('data.api.trigger.comment')+"；"
                    break;
                case 7:
                    time += React.language('data.api.trigger.comment.edit')+"；"
                    break;
            }
        })
        time = time.substr(0, time.length - 1);
        return time
    }
    openStructureForm = (d) =>{
        return ()=>{
            BsySlidePane({
                title: React.language('data.api.form.structure'),
                hasHeader: true,
                onContentCreate: (ref) => {
                    return <BsyStructureSlide data={d} type={2}/>
                },
            })
        }
    }
    openDocForm = (d) =>{
        return ()=>{
            BsySlidePane({
                title: React.language('data.api.doc.title'),
                hasHeader: true,
                onContentCreate: (ref) => {
                    return <BsyWebhookDoc data={d} type={2}/>
                },
            })
        }
    }

    switchStatus = (val) =>{
        return (event)=>{
            const e = event.currentTarget;
            const t = this;
            val.type = 2;
            window.FX.Msg.alert({
                type: "query",
                title:  val.status === 0 ? React.language("activated.webhook.tip") : React.language("deactivated.webhook.tip"),
                msg:  val.status === 0 ? React.language("activated.form.tip1") : React.language("deactivated.form.tip1"),
                text4Ok: val.status === 0 ? React.language('enable') : React.language('deactivate'),
                onOk: function () {
                    if(val.status === 0) {
                        val.status = 1;
                    }else {
                        val.status = 0;
                    }
                    React.axios("/webhook/update",{
                        ...val
                    }).then((res)=>{
                        if(res.data.errcode === 1){
                            tipAlert({
                                type:"error",
                                msg:res.data.errmsg
                            })
                            return
                        }
                        t.loadWebHook()
                    })
                }
            });
        }
    }
    deleteWebhook = (d) =>{
        return (event)=>{
            const e = event.currentTarget;
            const t = this;
            window.FX.Msg.alert({
                type: "warning",
                title:  React.language("delete.webhook.tip"),
                msg:  React.language("delete.webhook.form.tip1"),
                text4Ok: React.language('delete'),
                onOk: function () {
                    React.axios("/webhook/delete",{
                        id:d.id
                    }).then((res)=>{
                        e.parentNode.parentNode.parentNode.parentNode.remove();
                    })
                }
            });
        }
    }

    againPush = (d) =>{
        return (event)=>{
            const e = event.currentTarget;
            window.FX.Msg.alert({
                type: "query",
                title:  React.language("retry.webhook.tip"),
                text4Ok: React.language('ok'),
                onOk: function () {
                    React.axios("/webhook/retry",{
                        id:d.id
                    }).then((res)=>{
                        tipAlert({
                            type: 'success',
                            msg: React.language('retry.webhook.tip1')
                        })
                        e.parentNode.parentNode.remove()
                    })
                }
            });
        }
    }

    discardPush = (d) =>{
        return (event)=>{
            const e = event.currentTarget;
            window.FX.Msg.alert({
                type: "query",
                title:  React.language("abandon.webhook.tip"),
                text4Ok: React.language('ok'),
                onOk: function () {
                    React.axios("/webhook/abandon",{
                        id:d.id
                    }).then((res)=>{
                        e.parentNode.parentNode.remove()
                    })
                }
            });
        }
    }

    dashboardMenuCenterMenu = () =>{
        return <div className="open-header">
            <NavLink activeClassName="select" className="api-webhook" to={window.rootDirectroy + "/open/api"}>
                <div className="header-btn"><span>api</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="key-webhook" to={window.rootDirectroy + "/open/key"}>
                <div className="header-btn"><span>{React.language('key.management')}</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="form-webhook" to={window.rootDirectroy + "/open/webhook"}>
                <div className="header-btn"><span>webhook</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="modules-webhook" to={window.rootDirectroy + "/open/modules"}>
                <div className="header-btn"><span>{React.language('module')}</span></div>
            </NavLink>
            {window.FX.STATIC["user_corps"]["mode"] === "common" && <NavLink activeClassName="select" className="sso-webhook" to={window.rootDirectroy + "/open/sso"}>
                <div className="header-btn"><span>{React.language('account.signin.sso')}</span></div>
            </NavLink>}
        </div>
    }

    leftTitle = () =>{
        return <div className="leftTitle">
            <span>{React.language('open.platform')}</span>
        </div>
    }

    render() {
        const {list,openapi,success} = this.state;
        let enableList = [];
        let pauseList = [];
        list.map((val)=>{
            if(val.status === 1){
                enableList.push(val)
            }else if(val.status === 0){
                pauseList.push(val)
            }
        })
        return (
            <div className="BsyWebhookPane">
                {success && <div className="open-pane">
                    {list.length > 0 ? <div className="openList">
                        <div className="enableOpenList">
                            <div className="openListTitle">
                                <div className="open-state"><i
                                    className="icon-webhook-enable"/><span>{React.language('activated.setting')}</span>
                                </div>
                                <div className="title-create">
                                    {openapi && <div className="createBtn" onClick={this.createWebHook()}><i
                                        className="icon-bsy-add"/><span>{React.language('create')}</span></div>}
                                </div>
                            </div>
                            <ul>
                                {
                                    enableList.length > 0 && enableList.map((val) => {
                                        return val.status === 1 && <li>
                                            <div className="webhook-content-body-list">
                                                <div className="headerItem">
                                                    <div className="headerLeft">
                                                        {val.forminfo && <div className="formTitle">
                                                            {val.forminfo.appinfo && <>
                                                                <div className="appName">
                                                                    <div
                                                                        className={`app-icon color-cover-${val.forminfo.appinfo.style.color}`}>
                                                                        <div
                                                                            className={`imgbg-bby-app imgbg-bby-app-${val.forminfo.appinfo.style.icon}`}/>
                                                                    </div>
                                                                    <span>{val.forminfo.appinfo.appname}</span>
                                                                </div>
                                                                <div className="line-center"/>
                                                            </>
                                                            }

                                                            <div className="formName"
                                                                    style={{marginLeft: val.forminfo.appinfo ? "5px" : ""}}>
                                                                <i className={`node-icon icon-bsy-${val.forminfo.type}${val.forminfo.hasCoop ? "" : "-flow"} ${val.forminfo.icon<=24?`icon-bsy-form-'${val.forminfo.icon}`:`icon-new-bsy-form-'${val.forminfo.icon}`}`}/>
                                                                <span>{val.forminfo.name}</span>
                                                            </div>
                                                        </div>}
                                                        <div className="webhook-log">
                                                            <div className="log-btn" onClick={this.openWebHookLog(val)}>
                                                                <span>{React.language('data.api.log')}</span></div>
                                                        </div>
                                                    </div>
                                                    <div className="headerOptions">
                                                        <div className="headerOptionsLeft">
                                                            <div className="optBtn" onClick={this.openDocForm(val)}>
                                                                <span>{React.language('data.api.doc.title')}</span>
                                                            </div>
                                                        </div>
                                                        <div className="headerOptionsRight">
                                                            {openapi && <div className="optBtn"
                                                                                onClick={this.switchStatus(val)}><span
                                                                className={val.status === 0 ? "green" : ""}>{React.language('deactivate')}</span>
                                                            </div>}
                                                            {openapi &&
                                                            <div className="optBtn edit" onClick={this.createWebHook(val)}>
                                                                <span>{React.language('edit')}</span></div>}
                                                            <div className="optBtn" onClick={this.deleteWebhook(val)}>
                                                                <span>{React.language('delete')}</span></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="contItem">
                                                    <div className="server-cont">
                                                        <span>{React.language('data.api.serverUrl')}</span>
                                                        <b>{val.url}</b>
                                                    </div>
                                                    {
                                                        val.event_info.length > 0 &&
                                                        <div className="time-cont">
                                                            <span>{React.language('push.event') + "："}</span>
                                                            <b>{this.timeCont(val.event_info)}</b>
                                                        </div>
                                                    }
                                                    {val.fail !== 0 && <div className="webhook-error-detail">
                                                        <div
                                                            className="error-detail">{React.language('data.api.fail.tip1', {count: val.fail})}</div>
                                                        {openapi && <div className="error-btn">
                                                            <div className="optBtn" onClick={this.againPush(val)}>
                                                                <span>{React.language('data.api.push.again')}</span>
                                                            </div>
                                                            <div className="optBtn" onClick={this.discardPush(val)}>
                                                                <span>{React.language('data.api.push.discard')}</span>
                                                            </div>
                                                        </div>}
                                                    </div>}
                                                </div>
                                            </div>
                                        </li>
                                    })
                                }
                            </ul>
                        </div>
                        {pauseList.length > 0 && <div className="pauseOpenList">
                            <div className="openListTitle">
                                <div className="open-state"><i
                                    className="icon-webhook-deactivate"/><span>{React.language('stoped.setting')}</span>
                                </div>
                            </div>
                            <ul>
                                {
                                    pauseList.length > 0 && pauseList.map((val) => {
                                        return val.status === 0 && <li>
                                            <div className="webhook-content-body-list">
                                                <div className="headerItem">
                                                    <div className="headerLeft">
                                                        {val.forminfo && <div className="formTitle">
                                                            {val.forminfo.appinfo && <>
                                                                <div className="appName">
                                                                    <div
                                                                        className={`app-icon color-cover-${val.forminfo.appinfo.style.color}`}>
                                                                        <div
                                                                            className={`imgbg-bby-app imgbg-bby-app-${val.forminfo.appinfo.style.icon}`}/>
                                                                    </div>
                                                                    <span>{val.forminfo.appinfo.appname}</span>
                                                                </div>
                                                                <div className="line-center"/>
                                                            </>
                                                            }

                                                            <div className="formName"
                                                                    style={{marginLeft: val.forminfo.appinfo ? "5px" : ""}}>
                                                                <i className={`node-icon icon-bsy-${val.forminfo.type}${val.forminfo.hasCoop ? "" : "-flow"} ${val.forminfo.icon<=24?`icon-bsy-form-'${val.forminfo.icon}`:`icon-new-bsy-form-'${val.forminfo.icon}`}`}/>
                                                                <span>{val.forminfo.name}</span>
                                                            </div>
                                                        </div>}
                                                        <div className="webhook-log">
                                                            <div className="log-btn" onClick={this.openWebHookLog(val)}>
                                                                <span>{React.language('data.api.log')}</span></div>
                                                        </div>
                                                    </div>
                                                    <div className="headerOptions">
                                                        <div className="headerOptionsLeft">
                                                            <div className="optBtn" onClick={this.openDocForm(val)}>
                                                                <span>{React.language('data.api.doc.title')}</span>
                                                            </div>
                                                        </div>
                                                        <div className="headerOptionsRight">
                                                            {openapi &&
                                                            <div className="optBtn"
                                                                    onClick={this.switchStatus(val)}><span
                                                                className={val.status === 0 ? "green" : ""}>{React.language('enable')}</span>
                                                            </div>}
                                                            {openapi &&
                                                            <div className="optBtn edit" onClick={this.createWebHook(val)}>
                                                                <span>{React.language('edit')}</span></div>}
                                                            <div className="optBtn" onClick={this.deleteWebhook(val)}>
                                                                <span>{React.language('delete')}</span></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="contItem">
                                                    <div className="server-cont">
                                                        <span>{React.language('data.api.serverUrl')}</span>
                                                        <b>{val.url}</b>
                                                    </div>
                                                    {
                                                        val.event_info.length > 0 &&
                                                        <div className="time-cont">
                                                            <span>{React.language('push.event') + "："}</span>
                                                            <b>{this.timeCont(val.event_info)}</b>
                                                        </div>
                                                    }
                                                    {val.fail !== 0 && <div className="webhook-error-detail">
                                                        <div
                                                            className="error-detail">{React.language('data.api.fail.tip1', {count: val.fail})}</div>
                                                        {openapi && <div className="error-btn">
                                                            <div className="optBtn" onClick={this.againPush(val)}>
                                                                <span>{React.language('data.api.push.again')}</span>
                                                            </div>
                                                            <div className="optBtn" onClick={this.discardPush(val)}>
                                                                <span>{React.language('data.api.push.discard')}</span>
                                                            </div>
                                                        </div>}
                                                    </div>}
                                                </div>
                                            </div>
                                        </li>
                                    })
                                }
                            </ul>
                        </div>}
                    </div> : <div className="openListEmpty">
                        <div className="emptyCont">
                            <div className="emptyImg">
                                <img style={{width:openapi ? "108px" : "260px"}} src={openapi ? wushujutuisong : imgkfptweihuoqu} alt=""/>
                            </div>
                            <div className="emptyTip">
                                <span>{openapi ? React.language("open.platform.empty.tip") : React.language("purview.webhook.tip1")}</span>
                            </div>
                            <div className="emptyBtn">
                                {openapi && <div className="emptyCreateBtn" onClick={this.createWebHook()}>
                                    <span>{React.language("data.api.create")}</span>
                                </div>}
                            </div>
                        </div>
                    </div>}
                </div>}
            </div>
        );
    }
}

export default BsyWebhookPane;